import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'

import { getVisibleActions } from '../../../navigation/actions'
import { getNavIcon } from '../../../navigation/icons'
import { useNavContext } from '../../../navigation/useNavigation'

// The header's + menu. The actions themselves (labels, urls, gating) live in
// src/navigation/actions.js, shared with the global search dialog.
const QuickAdd = () => {
  const ctx = useNavContext()
  const [anchorEl, setAnchorEl] = useState(null)
  const navigate = useNavigate()

  const actions = getVisibleActions(ctx)

  return (
    <>
      <AddIcon
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color: 'primary.main', cursor: 'pointer' }}
      />
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.id}
            onClick={() => {
              navigate(action.path)
              setAnchorEl(null)
            }}
            disableRipple
            dense
          >
            <Box display="flex" gap={1} alignItems="center">
              {React.cloneElement(getNavIcon(action.icon), {
                color: action.iconColor,
              })}
              <Typography>{action.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default QuickAdd
